module.exports = "<ng-container *ngIf=\"message\">\n    <p></p>\n<div  [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }\">    \n    {{message.text}}\n</div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/fulfillment.release/src/app/alert/alert.component.html
// module id = ../../../../../src/app/alert/alert.component.html
// module chunks = 0